<template>
    <section class="features">
      <div class="container">
        <div class="features-grid">
          <div class="feature-card" v-for="feature in features" :key="feature.id">
            <div class="feature-icon">
              <i :class="feature.icon"></i>
            </div>
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'FeaturesSection',
    data() {
      return {
        features: [
          {
            id: 1,
            icon: 'fas fa-truck',
            title: 'Free Shipping',
            description: 'On orders over $50'
          },
          {
            id: 2,
            icon: 'fas fa-undo',
            title: 'Easy Returns',
            description: '30 days return policy'
          },
          {
            id: 3,
            icon: 'fas fa-lock',
            title: 'Secure Payment',
            description: '100% secure checkout'
          },
          {
            id: 4,
            icon: 'fas fa-headset',
            title: '24/7 Support',
            description: 'Dedicated support team'
          }
        ]
      }
    }
  }
  </script>
  
  <style scoped>
  .features {
    padding: 60px 0;
    background-color: var(--white);
  }
  
  .features-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
  }
  
  .feature-card {
    text-align: center;
  }
  
  .feature-icon {
    font-size: 36px;
    color: var(--primary-color);
    margin-bottom: 15px;
  }
  
  .feature-card h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  
  .feature-card p {
    color: var(--text-light);
  }
  
  @media (max-width: 992px) {
    .features-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 40px;
    }
  }
  
  @media (max-width: 576px) {
    .features-grid {
      grid-template-columns: 1fr;
    }
  }
  </style>